import { atom, useAtom } from 'jotai';
import { useWindowDimensions } from 'react-native';

import { atomWithStorage } from '../common/providers/StorageProvider';
import { StorageKey } from '../common/types/Storage';

const MIN_SIDEBAR_RAIL_WIDTH = 280;
const DEFAULT_SIDEBAR_RAIL_WIDTH = 380;
const MAX_SIDEBAR_RAIL_VIEWPORT_FRACTION = 0.8;

export const sidebarRailOpenAtom = atom(false);

export const sidebarSliceIdAtom = atomWithStorage<string | null>(
    StorageKey.SIDEBAR_FRUIT_SLICE_ID,
    null,
);

const sidebarRailWidthAtom = atomWithStorage<number>(
    StorageKey.SIDEBAR_RAIL_WIDTH,
    DEFAULT_SIDEBAR_RAIL_WIDTH,
);

export const useSidebarRailWidth = () => {
    const { width: viewportWidth } = useWindowDimensions();
    const [storedWidth, setStoredWidth] = useAtom(sidebarRailWidthAtom);

    const clamp = (value: number) =>
        Math.min(
            Math.max(value, MIN_SIDEBAR_RAIL_WIDTH),
            Math.max(
                MIN_SIDEBAR_RAIL_WIDTH,
                Math.round(viewportWidth * MAX_SIDEBAR_RAIL_VIEWPORT_FRACTION),
            ),
        );

    return {
        width: clamp(storedWidth),
        setWidth: (next: number) => {
            setStoredWidth(clamp(next));
        },
    };
};
